import React from 'react';
import './About.css';
import picture from './images/picture.jpg';
import linkedin from './images/linkedin.webp';
import html from './images/html.png';
import css from './images/css.png';
import javascript from './images/java-script.png';
import react from './images/react.png';
import node from './images/node-js.png';
import c from './images/c++.png';
import java from './images/java.png';
import python from './images/python.png';
import typescript from './images/typescript.png';
import sql from './images/Sql_data_base_with_logo.png';
import r from './images/R_logo.svg.png';
import mongodb from './images/mongodb.png';
import tailwind from './images/Tailwind_CSS_Logo.svg.png';
import puppeteer from './images/puppeeteer.png';

const About = () => {
  return (
    <div className="about">
      <div className="notion-page">
        <div className="notion-page-header">
          <div>
            <h1 className="notion-page-title">Hey, I'm Christian</h1>
            <div className="notion-page-description">
              <a href="https://linkedin.com/in/05chrs" target="_blank" rel="noopener noreferrer" className="social-link">
                <img src={linkedin} width="24px" height="24px" alt="LinkedIn" className="linkedin-logo-black" />
              </a>
              <a href="https://github.com/05chrs" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ verticalAlign: 'middle', marginLeft: '8px' }}>
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="about-intro-container">
        <div className="about-image-wrapper">
          <img src={picture} alt="Me in France" className="about-image" />
        </div>
        <div className="about-text-wrapper">
          <div className="notion-block">
            <p>
              I'm Christian, a sophomore computer science student at Yale and Yale Engineering and Science (YES) Scholar.
            </p>
          </div>

          <div className="notion-block">
            <p>
              I'm Half-Puerto Rican, Half-Laotian, and I'm originally from the Atlanta suburbs. In high school, I was passionate about physics and played the cello for 12+ years, touring countries like Greece, Macedonia, France, Dominican Republic, and Canada and playing at Carnegie Hall.
            </p>
          </div>

          <div className="notion-block">
            <p>
              Now I'm passionate about tech, startups, and content creation. I create my personal college lifestyle and advice content on Instagram, create UGC for startups (Cluely, Turbo AI, Crackd), and I drive growth at my own startup, Collegebase (0 to 70K+ Users).
            </p>
          </div>

          <div className="notion-block">
            <p>
              Ultimately, I want to use my short time on this planet to create and scale technology that changes our lives while building a community of driven people around me.
            </p>
          </div>
        </div>
      </div>

      <div className="notion-callout" style={{ marginTop: '32px', position: 'relative' }}>
        <span className="notion-callout-icon">📄</span>
        <div className="notion-callout-content">
          <h3 style={{ fontSize: '18px', fontWeight: 'var(--font-weight-semibold)', marginBottom: '12px' }}>Resume</h3>
          <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: 'var(--radius)' }}>
            <iframe
              src="https://drive.google.com/file/d/1mqZ820EKbrGp_pH-meAcF4SJ7VlcTF1U/preview"
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
              title="Resume"
            ></iframe>
          </div>
        </div>
      </div>

      <div className="notion-page" style={{ marginTop: '48px' }}>
        <div className="notion-page-header">
          <h2 className="notion-page-title" style={{ fontSize: '24px' }}>Education</h2>
        </div>
      </div>

      <div className="notion-callout">
        <span className="notion-callout-icon">🏫</span>
        <div className="notion-callout-content">
          <h3 style={{ fontSize: '18px', fontWeight: 'var(--font-weight-semibold)', marginBottom: '4px' }}>Yale University</h3>
          <p style={{ color: 'var(--text-secondary)', fontSize: '14px', marginBottom: '4px' }}>Bachelor's in Computer Science, 2028</p>
          <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>GPA: 3.93/4.0</p>
        </div>
      </div>

      <div className="notion-callout">
        <span className="notion-callout-icon">📚</span>
        <div className="notion-callout-content">
          <h3 style={{ fontSize: '18px', fontWeight: 'var(--font-weight-semibold)', marginBottom: '4px' }}>Wheeler High School</h3>
          <p style={{ color: 'var(--text-secondary)', fontSize: '14px', marginBottom: '4px' }}>High School Diploma, 2024</p>
          <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>GPA: 4.697/4.0</p>
        </div>
      </div>

      <div className="notion-page" style={{ marginTop: '48px' }}>
        <div className="notion-page-header">
          <h2 className="notion-page-title" style={{ fontSize: '24px' }}>Skills</h2>
        </div>
      </div>

      <div className="skills-section">
        <div className="skills-grid">
          <div className="skill-item">
            <img src={python} alt="Python" className="skill-logo-black" />
            <span>Python</span>
          </div>
          <div className="skill-item">
            <img src={c} alt="C++" className="skill-logo-black" />
            <span>C/C++</span>
          </div>
          <div className="skill-item">
            <img src={java} alt="Java" className="skill-logo-black" />
            <span>Java</span>
          </div>
          <div className="skill-item">
            <img src={javascript} alt="JavaScript" className="skill-logo-black" />
            <span>JavaScript</span>
          </div>
          <div className="skill-item">
            <img src={typescript} alt="TypeScript" className="skill-logo-black" />
            <span>TypeScript</span>
          </div>
          <div className="skill-item">
            <img src={html} alt="HTML" className="skill-logo-black" />
            <span>HTML</span>
          </div>
          <div className="skill-item">
            <img src={css} alt="CSS" className="skill-logo-black" />
            <span>CSS</span>
          </div>
          <div className="skill-item">
            <img src={sql} alt="SQL" className="skill-logo-black" />
            <span>SQL</span>
          </div>
          <div className="skill-item">
            <img src={r} alt="R" className="skill-logo-black" />
            <span>R</span>
          </div>
          <div className="skill-item">
            <img src={react} alt="React" className="skill-logo-black" />
            <span>React</span>
          </div>
          <div className="skill-item">
            <img src={node} alt="Node.js" className="skill-logo-black" />
            <span>Node.js</span>
          </div>
          <div className="skill-item">
            <img src={mongodb} alt="MongoDB" className="skill-logo-black" />
            <span>MongoDB</span>
          </div>
          <div className="skill-item">
            <img src={tailwind} alt="Tailwind" className="skill-logo-black" />
            <span>Tailwind</span>
          </div>
          <div className="skill-item">
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Flask</span>
            <span>Flask</span>
          </div>
          <div className="skill-item">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" className="skill-logo-black">
              <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
            </svg>
            <span>Git</span>
          </div>
          <div className="skill-item">
            <img src={puppeteer} alt="Puppeteer" className="skill-logo-black" />
            <span>Puppeteer</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;